











































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import { layout } from '@/modules/shared/shared/store/namespaces';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { TutorialsView } from '@/modules/infodayco/shared/domain/tutorials.view';
import { GuideView } from '@/modules/infodayco/shared/domain/guide.view';
import InfoFileBox from '@/modules/infodayco/shared/components/InfoFileBox.vue';
import { TutorialFile } from '@/modules/infodayco/shared/domain/tutorial-file';
import { serviceModels } from '@/modules/infodayco/shared/store/namespaces';
import { ServiceModelsActions } from '@/modules/infodayco/service-model/store/service-models.actions';
import { GuideFile } from '@/modules/infodayco/shared/domain/guide-file';
import { ServiceModelsGetters } from '@/modules/infodayco/service-model/store/service-models.getters';
import BaseModal from '@/modules/shared/layouts/components/BaseModal.vue';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';

@Component({
    name: 'service-model',
    components: { BaseModal, InfoFileBox, SectionTitle },
})
export default class ServiceModel extends Vue {
    private isLoading: boolean = false;
    private loadingDelete: boolean = false;

    private toDeleteFile: GuideFile | null = null;

    $refs!: {
        modal: any;
    };

    async mounted() {
        this.changeTitle({
            title: 'ACUERDOS DE SERVICIO',
            route: ['MIS GUÍAS Y TUTORIALES'],
        });
        this.isLoading = true;
        const failed = await this.fetchView();
        if (failed) {
            failed.showError();
        }
        this.isLoading = false;
    }

    public get isEmpty(): boolean {
        return !(this.view.guides.length > 0);
    }

    public async openFile(file: GuideFile) {
        const failed = await this.download(file);
        if (failed) {
            failed.showError();
        }
    }

    public async deleteFile(file: TutorialFile) {
        this.toDeleteFile = file;
        this.$refs.modal.openModal();
    }

    private async executeDelete() {
        this.loadingDelete = true;
        const failed = await this.deleteServiceModel(this.toDeleteFile!);
        if (failed) {
            failed.showError();
        } else {
            EventBus.$emit(
                EventBusMessages.SHOW_SUCCESS,
                'Se ha eliminado el archivo de manera satisfactoria',
            );
        }
        this.loadingDelete = false;
        this.$refs.modal.closeModal();
    }

    @serviceModels.Action(ServiceModelsActions.FETCH_VIEW)
    fetchView!: () => Promise<RequestResponse>;

    @serviceModels.Action(ServiceModelsActions.DOWNLOAD_SERVICE_MODEL)
    download!: (guide: GuideFile) => Promise<RequestResponse>;

    @serviceModels.Action(ServiceModelsActions.DELETE_SERVICE_MODEL)
    deleteServiceModel!: (guide: GuideFile) => Promise<RequestResponse>;

    @serviceModels.Getter(ServiceModelsGetters.GET_VIEW)
    view!: GuideView;

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (layout: LayoutTitle) => void;
}
